
import React, { useState } from 'react';
import { Button } from '@/components/ui/button';
import { Loader2 } from 'lucide-react';
import { toast } from 'sonner';
import { supabase } from '@/integrations/supabase/client';

const TestEmailButton = () => {
  const [isSending, setIsSending] = useState(false);

  const sendTestEmail = async () => {
    setIsSending(true);
    
    try {
      console.log("Invocation de la fonction Edge test-email...");
      const { data, error } = await supabase.functions.invoke('test-email', {
        method: 'POST',
      });
      
      if (error) {
        console.error("Erreur d'invocation:", error);
        throw new Error(`Erreur d'invocation: ${error.message}`);
      }
      
      // Vérifier si la réponse contient une erreur, même si le statut HTTP est 200
      if (data && data.error) {
        console.error("Erreur retournée par la fonction:", data);
        if (data.error.includes("Configuration d'envoi d'email manquante")) {
          throw new Error(`Configuration d'envoi d'email manquante`);
        } else {
          throw new Error(`Erreur: ${data.error}${data.details ? ` - ${data.details}` : ''}`);
        }
      }
      
      toast.success("Email de test envoyé avec succès à christophe.bouron@gmail.com");
      console.log('Résultat de l\'envoi:', data);
    } catch (error) {
      console.error('Erreur lors de l\'envoi de l\'email de test:', error);
      
      // Afficher un message plus détaillé sur l'erreur de configuration
      if (error.message && error.message.includes("Configuration d'envoi d'email manquante")) {
        toast.error("La clé API Brevo n'est pas configurée. Veuillez configurer BREVO_API_KEY dans les secrets de la fonction Edge.");
      } else {
        toast.error(`Échec de l'envoi de l'email de test: ${error.message}`);
      }
    } finally {
      setIsSending(false);
    }
  };

  return (
    <Button 
      variant="outline" 
      onClick={sendTestEmail} 
      disabled={isSending}
      className="mt-4"
    >
      {isSending ? (
        <>
          <Loader2 className="mr-2 h-4 w-4 animate-spin" />
          Envoi en cours...
        </>
      ) : "Envoyer un email de test"}
    </Button>
  );
};

export default TestEmailButton;
